import { useState, useRef, useEffect } from "react";
import api, { apiError } from "../lib/api";
import { Sparkles, X, Send, Loader2 } from "lucide-react";

const SUGGESTIONS = ["Berapa profit hari ini?", "Berapa volume transaksi hari ini?", "Stok USDT berapa?", "Ada transaksi menunggu approval?"];

export default function Assistant() {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const endRef = useRef(null);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs, loading]);

  const send = async (text) => {
    const question = (text ?? q).trim();
    if (!question || loading) return;
    setMsgs((m) => [...m, { role: "user", text: question }]);
    setQ("");
    setLoading(true);
    try {
      const r = await api.post("/assistant/ask", { question });
      setMsgs((m) => [...m, { role: "ai", text: r.data.answer }]);
    } catch (e) {
      setMsgs((m) => [...m, { role: "ai", text: "⚠️ " + apiError(e) }]);
    } finally { setLoading(false); }
  };

  return (
    <>
      <button data-testid="assistant-fab" onClick={() => setOpen(true)}
        className="fixed z-[55] bottom-24 lg:bottom-6 right-4 h-14 w-14 rounded-full flex items-center justify-center shadow-xl shadow-black/50 active:scale-90 transition-transform"
        style={{ background: "linear-gradient(135deg,#EAB308,#CA8A04)" }}>
        <Sparkles className="h-6 w-6 text-[#0B0E14]" />
      </button>

      {open && (
        <div className="fixed inset-0 z-[70] flex items-end sm:items-center sm:justify-end bg-black/60 backdrop-blur-sm" onClick={() => setOpen(false)}>
          <div data-testid="assistant-panel" onClick={(e) => e.stopPropagation()}
            className="nnx-card w-full sm:max-w-md h-[80vh] sm:h-[600px] sm:mr-6 rounded-t-2xl sm:rounded-2xl flex flex-col">
            <div className="flex items-center justify-between p-4 border-b border-[#222B3D]">
              <div className="flex items-center gap-2">
                <div className="h-8 w-8 rounded-lg flex items-center justify-center" style={{ background: "linear-gradient(135deg,#EAB308,#CA8A04)" }}>
                  <Sparkles className="h-4 w-4 text-[#0B0E14]" />
                </div>
                <div>
                  <div className="font-head font-bold">NNX Assistant</div>
                  <div className="text-[10px] text-[#64748B]">Tanya data bisnis Anda</div>
                </div>
              </div>
              <button data-testid="assistant-close" onClick={() => setOpen(false)} className="p-1.5 rounded-lg hover:bg-[#222B3D]"><X className="h-5 w-5" /></button>
            </div>

            <div className="flex-1 overflow-y-auto p-4 space-y-3">
              {msgs.length === 0 && (
                <div className="space-y-3">
                  <p className="text-sm text-[#94A3B8]">Contoh pertanyaan:</p>
                  {SUGGESTIONS.map((s) => (
                    <button key={s} data-testid={`suggest-${s.slice(0, 10)}`} onClick={() => send(s)}
                      className="chip w-full text-left hover:border-[#EAB308]">{s}</button>
                  ))}
                </div>
              )}
              {msgs.map((m, i) => (
                <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                  <div className={`max-w-[85%] rounded-2xl px-3.5 py-2.5 text-sm whitespace-pre-wrap ${m.role === "user" ? "bg-[#EAB308] text-[#0B0E14]" : "bg-[#0B0E14] border border-[#222B3D]"}`}>{m.text}</div>
                </div>
              ))}
              {loading && <div className="flex justify-start"><div className="rounded-2xl px-3.5 py-2.5 bg-[#0B0E14] border border-[#222B3D]"><Loader2 className="h-4 w-4 animate-spin text-[#EAB308]" /></div></div>}
              <div ref={endRef} />
            </div>

            <div className="p-3 border-t border-[#222B3D] flex gap-2">
              <input data-testid="assistant-input" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
                placeholder="Tulis pertanyaan..." className="nnx-input flex-1" />
              <button data-testid="assistant-send" onClick={() => send()} disabled={loading} className="btn-gold px-3"><Send className="h-4 w-4" /></button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
